/**
 * Turning "set this call to Completed" into one `BookingItem`.
 *
 * Since `1f1b855` this is always an **UPDATE by the booking's own `id`**. A
 * booking is one row whose status is the newest `BookingStatusHistory` entry,
 * and the server appends that entry itself — so the trail the activity drawer
 * shows is kept by the backend, and there is no ADD-vs-UPDATE choice to make
 * here any more. (It used to be a matrix: ADD a new row to close out an open
 * call, UPDATE to correct one, because the old table *was* the trail.)
 *
 * The UPDATE carries `id` + `booking_status_id`, plus `status_reason` when a
 * note was typed. Everything else is left out on purpose: `user_id`,
 * `coach_id` and the times are immutable and sending any of them is a 400.
 * A blank note is omitted rather than sent as `""` — the reason belongs to
 * this one status change, and an empty string would record "no reason" as if
 * somebody had typed it.
 *
 * No React, no API — unit-testable in isolation.
 */

/**
 * Build the single `BookingItem` for a status change.
 *
 * @param {Object} params
 * @param {Object} params.booking - The row the action was raised from; only its `id` is read.
 * @param {string} params.statusId - `StatusUtils.id` for the target.
 * @param {string} [params.reason] - The note typed in the modal, if any.
 * @returns {{ operation: 'UPDATE', id: string, booking_status_id: string, status_reason?: string }}
 */
export function planStatusWrite({ booking, statusId, reason } = {}) {
  const note = typeof reason === "string" ? reason.trim() : "";
  const item = {
    operation: "UPDATE",
    id: booking?.id,
    booking_status_id: statusId,
  };
  if (note) item.status_reason = note;
  return item;
}
